"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeWithFallbacks = exports.defaultEncoder = exports.Base64UrlEncoder = exports.Base64Encoder = void 0;
var Base64Encoder = /** @class */ (function () {
    function Base64Encoder() {
        this.name = 'base64';
    }
    Base64Encoder.prototype.encode = function (buffer) {
        var bytes = new Uint8Array(buffer);
        var binary = bytes.reduce(function (acc, byte) { return acc + String.fromCharCode(byte); }, '');
        return btoa(binary);
    };
    Base64Encoder.prototype.decode = function (str) {
        var binary = atob(str);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes.buffer;
    };
    return Base64Encoder;
}());
exports.Base64Encoder = Base64Encoder;
var Base64UrlEncoder = /** @class */ (function () {
    function Base64UrlEncoder() {
        this.name = 'base64url';
    }
    Base64UrlEncoder.prototype.encode = function (buffer) {
        var bytes = new Uint8Array(buffer);
        var binary = bytes.reduce(function (acc, byte) { return acc + String.fromCharCode(byte); }, '');
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    };
    Base64UrlEncoder.prototype.decode = function (str) {
        var base64 = str.replace(/-/g, '+').replace(/_/g, '/');
        var padding = (4 - (base64.length % 4)) % 4;
        var padded = base64 + '='.repeat(padding);
        var binary = atob(padded);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes.buffer;
    };
    return Base64UrlEncoder;
}());
exports.Base64UrlEncoder = Base64UrlEncoder;
exports.defaultEncoder = new Base64UrlEncoder();
function decodeWithFallbacks(str, encoders) {
    for (var _i = 0, encoders_1 = encoders; _i < encoders_1.length; _i++) {
        var encoder = encoders_1[_i];
        try {
            return encoder.decode(str);
        }
        catch (_a) { }
    }
    throw new Error("Failed to decode with ".concat(encoders.length, " encoders"));
}
exports.decodeWithFallbacks = decodeWithFallbacks;
